import React from 'react';

import { AlertIcon } from './components/AlertIcon/AlertIcon';
import { Container } from './AlertBox.styles';
import { AlarmIcon } from './components/AlarmIcon/AlarmIcon';

interface AlertBoxProps {
	isEndedCampaign: boolean;
	filledCampaign: boolean;
	isLoading: boolean;
	hasLasThanThreeDays: boolean;
}

export const AlertBox = ({
	isEndedCampaign,
	filledCampaign,
	isLoading,
	hasLasThanThreeDays,
}: AlertBoxProps): JSX.Element => {
	if (isLoading) {
		return <></>;
	}

	if (isEndedCampaign && !filledCampaign) {
		return (
			<Container>
				<header>
					<AlertIcon />
					<h2>Amplia la fecha de cierre</h2>
				</header>
				<p>
					Tus centros de trabajo no han alcanzado el porcentaje mínimo de
					respuestas requerido para cumplir la NOM-035.
				</p>
			</Container>
		);
	}

	if (!isEndedCampaign && !filledCampaign && hasLasThanThreeDays) {
		return (
			<Container>
				<header>
					<AlarmIcon />
					<h2>Tu campaña está por cerrar</h2>
				</header>
				<p>
					Tus centros de trabajo aún no han alcanzado el porcentaje de
					respuestas requerido, sugerimos ampliar la fecha de cierre.
				</p>
			</Container>
		);
	}

	return <></>;
};
